import "./EditGuardCompanies.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EditGuardCompaniesComponentController from "./EditGuardCompaniesComponentController";

export default class EditGuardCompaniesComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditGuardCompaniesComponentController;
        this.templateUrl = "/App/Components/Site/Overview/GuardCompanies/EditGuardCompanies/EditGuardCompanies.html";
    }
}

module("mmManagePortal").component("mmEditSiteGuardCompanies", new EditGuardCompaniesComponent());
